import * as angular from "angular";
import {IController} from "angular";

export class SpotsCapacityComponent implements IController {
  load: any;
  maxLoad: any;

  constructor() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('spotsCapacity', {
    bindings: {
      load: '<',
      maxLoad: '<'
    },
    templateUrl: 'app/modules/commons/components/spots-capacity/spots-capacity.html',
    controller: SpotsCapacityComponent
  });
